"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTabsRematricula = exports.schemaTabsRematricula = exports.yupConfigMatriculaRematricula = exports.schemaCamposMatriculaTransporteEscolar = exports.yupCamposMatriculaTransporteEscolar = exports.schemaCamposMatriculaPessoasAutorizadas = exports.yupCamposMatriculaPessoasAutorizadas = exports.schemaCamposMatriculaFinalizar = exports.yupCamposMatriculaFinalizar = exports.schemaCamposMatriculaFiador = exports.yupCamposMatriculaFiador = exports.schemaCamposMatriculaResponsavel = exports.yupCamposMatriculaResponsavel = exports.schemaCamposMatriculaFichaSaude = exports.yupCamposMatriculaFichaSaude = exports.schemaCamposMatriculaMae = exports.yupCamposMatriculaMae = exports.schemaCamposMatriculaPai = exports.yupCamposMatriculaPai = exports.schemaCamposMatriculaAluno = exports.yupCamposMatriculaAluno = exports.schemaCamposRematricula = exports.yupCamposRematricula = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../../enums");
exports.yupCamposRematricula = yup
    .object({
    edita: yup
        .mixed()
        .oneOf(Object.values(enums_1.EConfigEditaCampoRematricula))
        .required()
        .default(enums_1.EConfigEditaCampoRematricula.Não)
        .label('Editar'),
    valida: yup.boolean().required().nullable().default(false).label('Obrigatório'),
})
    .notRequired()
    .nullable()
    .default({
    edita: enums_1.EConfigEditaCampoRematricula.Não,
    valida: false,
});
exports.schemaCamposRematricula = exports.yupCamposRematricula.shape({});
exports.yupCamposMatriculaAluno = yup.object({
    NOME: exports.yupCamposRematricula.label('Nome'),
    DATA_NASC: exports.yupCamposRematricula.label('Data de Nascimento'),
    CPF: exports.yupCamposRematricula.label('CPF'),
    RG: exports.yupCamposRematricula.label('RG'),
    RG_EXP: exports.yupCamposRematricula.label('Órgão Expedidor'),
    RG_UF: exports.yupCamposRematricula.label('Unidade da Federação (UF)'),
    RG_EXPDT: exports.yupCamposRematricula.label('Data de Expedição'),
    ENDERECO: exports.yupCamposRematricula.label('Endereço'),
    NUMERO: exports.yupCamposRematricula.label('Número'),
    BLOCO: exports.yupCamposRematricula.label('Bloco'),
    APTO: exports.yupCamposRematricula.label('Apartamento'),
    BAIRRO: exports.yupCamposRematricula.label('Bairro'),
    CEP: exports.yupCamposRematricula.label('CEP'),
    CIDADE: exports.yupCamposRematricula.label('Cidade'),
    ESTADO: exports.yupCamposRematricula.label('Estado'),
    FONE: exports.yupCamposRematricula.label('Telefone (Residencial)'),
    CELULAR: exports.yupCamposRematricula.label('Celular'),
    FONE_RECAD: exports.yupCamposRematricula.label('Telefone (Recado)'),
    RAMAL: exports.yupCamposRematricula.label('Ramal'),
    CONTATO: exports.yupCamposRematricula.label('Contato'),
    EMAIL: exports.yupCamposRematricula.label('E-mail'),
    EST_CIVIL: exports.yupCamposRematricula.label('Estado Civil'),
    LOCAL_NASC: exports.yupCamposRematricula.label('Cidade de Nascimento'),
    UF_NASC: exports.yupCamposRematricula.label('Estado de Nascimento'),
    NASCIONA: exports.yupCamposRematricula.label('Nacionalidade'),
    ESC_ORI: exports.yupCamposRematricula.label('Escola de Origem'),
    ESC_ORI_UF: exports.yupCamposRematricula.label('Estado da Escola de Origem'),
    TURNO: exports.yupCamposRematricula.label('Turno'),
    RELIGIAO: exports.yupCamposRematricula.label('Religião'),
    SEXO: exports.yupCamposRematricula.label('Sexo'),
    CN_NOVA: exports.yupCamposRematricula.label('Modelos de certidão de nascimento'),
    CN_MAT: exports.yupCamposRematricula.label('Certidão de Nascimento - Modelo Novo'),
    CERTIDAO: exports.yupCamposRematricula.label('Certidão de Nascimento - Modelo Antigo'),
    CN_EMISSAO: exports.yupCamposRematricula.label('Emissão da Certidão de Nascimento'),
    CN_FL: exports.yupCamposRematricula.label('Folha da Certidão de Nascimento'),
    CN_LV: exports.yupCamposRematricula.label('Livro da Certidão de Nascimento'),
    CN_CART: exports.yupCamposRematricula.label('Cartório da Certidão de Nascimento'),
    CN_CID: exports.yupCamposRematricula.label('Cidade da Certidão de Nascimento'),
    CN_UF: exports.yupCamposRematricula.label('Estado da Certidão de Nascimento'),
    ALERGIA: exports.yupCamposRematricula.label('Alergia'),
    MEDICO: exports.yupCamposRematricula.label('Médico'),
    FONE_MEDIC: exports.yupCamposRematricula.label('Telefone do Médico'),
    REMEDIO: exports.yupCamposRematricula.label('Remédio'),
    CLINICA: exports.yupCamposRematricula.label('Clínica'),
    PLANOSAUDE: exports.yupCamposRematricula.label('Plano de Saúde'),
    TIPOSANGUE: exports.yupCamposRematricula.label('Tipo Sanguíneo'),
    RACA: exports.yupCamposRematricula.label('Raça'),
    VACINA_DT: exports.yupCamposRematricula.label('Data de Vacinação'),
});
exports.schemaCamposMatriculaAluno = exports.yupCamposMatriculaAluno.shape({});
exports.yupCamposMatriculaPai = yup.object({
    NOME_PAI: exports.yupCamposRematricula.label('Nome'),
    NASC_PAI: exports.yupCamposRematricula.label('Data de Nascimento'),
    CPF_PAI: exports.yupCamposRematricula.label('CPF'),
    RG_PAI: exports.yupCamposRematricula.label('RG'),
    FALEC_PAI: exports.yupCamposRematricula.label('Falecido'),
    DESAP_PAI: exports.yupCamposRematricula.label('Desaparecido'),
    END_PAI: exports.yupCamposRematricula.label('Endereço'),
    NUM_PAI: exports.yupCamposRematricula.label('Número'),
    BLOCO_PAI: exports.yupCamposRematricula.label('Bloco'),
    APTO_PAI: exports.yupCamposRematricula.label('Apartamento'),
    BAIRR_PAI: exports.yupCamposRematricula.label('Bairro'),
    CEP_PAI: exports.yupCamposRematricula.label('CEP'),
    CID_PAI: exports.yupCamposRematricula.label('Cidade'),
    UF_PAI: exports.yupCamposRematricula.label('Estado'),
    FONE_RPAI: exports.yupCamposRematricula.label('Telefone (Residencial)'),
    CEL_PAI: exports.yupCamposRematricula.label('Celular'),
    EMAIL_PAI: exports.yupCamposRematricula.label('E-mail'),
    CIVIL_PAI: exports.yupCamposRematricula.label('Estado Civil'),
    PROF_PAI: exports.yupCamposRematricula.label('Profissão'),
    TRAB_PAI: exports.yupCamposRematricula.label('Trabalho'),
    FONE_PAI: exports.yupCamposRematricula.label('Telefone (Comercial)'),
    RAMAL_PAI: exports.yupCamposRematricula.label('Ramal'),
    RELIG_PAI: exports.yupCamposRematricula.label('Religião'),
});
exports.schemaCamposMatriculaPai = exports.yupCamposMatriculaPai.shape({});
exports.yupCamposMatriculaMae = yup.object({
    NOME_MAE: exports.yupCamposRematricula.label('Nome'),
    NASC_MAE: exports.yupCamposRematricula.label('Data de Nascimento'),
    CPF_MAE: exports.yupCamposRematricula.label('CPF'),
    RG_MAE: exports.yupCamposRematricula.label('RG'),
    FALEC_MAE: exports.yupCamposRematricula.label('Falecida'),
    DESAP_MAE: exports.yupCamposRematricula.label('Desaparecida'),
    END_MAE: exports.yupCamposRematricula.label('Endereço'),
    NUM_MAE: exports.yupCamposRematricula.label('Número'),
    BLOCO_MAE: exports.yupCamposRematricula.label('Bloco'),
    APTO_MAE: exports.yupCamposRematricula.label('Apartamento'),
    BAIRR_MAE: exports.yupCamposRematricula.label('Bairro'),
    CEP_MAE: exports.yupCamposRematricula.label('CEP'),
    CID_MAE: exports.yupCamposRematricula.label('Cidade'),
    UF_MAE: exports.yupCamposRematricula.label('Estado'),
    FONE_RMAE: exports.yupCamposRematricula.label('Telefone (Residencial)'),
    CEL_MAE: exports.yupCamposRematricula.label('Celular'),
    EMAIL_MAE: exports.yupCamposRematricula.label('E-mail'),
    CIVIL_MAE: exports.yupCamposRematricula.label('Estado Civil'),
    PROF_MAE: exports.yupCamposRematricula.label('Profissão'),
    TRAB_MAE: exports.yupCamposRematricula.label('Trabalho'),
    FONE_MAE: exports.yupCamposRematricula.label('Telefone (Comercial)'),
    RAMAL_MAE: exports.yupCamposRematricula.label('Ramal'),
    RELIG_MAE: exports.yupCamposRematricula.label('Religião'),
});
exports.schemaCamposMatriculaMae = exports.yupCamposMatriculaMae.shape({});
exports.yupCamposMatriculaFichaSaude = yup.object({
    contato2: exports.yupCamposRematricula.label('Contato de emergência 2'),
    contato1: exports.yupCamposRematricula.label('Contato de emergência 1'),
    multipla: exports.yupCamposRematricula.label('Deficiência múltipla'),
    plano: exports.yupCamposRematricula.label('Plano de saúde'),
    vacina_dt: exports.yupCamposRematricula.label('Vacinas'),
    sangue: exports.yupCamposRematricula.label('Tipo Sanguíneo'),
    clinica: exports.yupCamposRematricula.label('Clínica'),
    super: exports.yupCamposRematricula.label('Altas habilidades / superdotação'),
    neuromotor: exports.yupCamposRematricula.label('Deficiência Neuromotora grave'),
    autista: exports.yupCamposRematricula.label('Transtorno de Espectro Autista'),
    diabetes: exports.yupCamposRematricula.label('Diabetes'),
    outra: exports.yupCamposRematricula.label('Outra'),
    hipotensao: exports.yupCamposRematricula.label('Hipotensão'),
    hipertenso: exports.yupCamposRematricula.label('Hipertensão'),
    hemofilia: exports.yupCamposRematricula.label('Hemofilia'),
    cardiopata: exports.yupCamposRematricula.label('Cardiopatia'),
    convulsao: exports.yupCamposRematricula.label('Convulsão / Doença Neurológica'),
    tireoide: exports.yupCamposRematricula.label('Tireóide'),
    rinite: exports.yupCamposRematricula.label('Rinite alérgica'),
    cjuntivite: exports.yupCamposRematricula.label('Conjuntivite'),
    asma: exports.yupCamposRematricula.label('Asma / Bronquite'),
    pomada: exports.yupCamposRematricula.label('Alergia a Pomadas'),
    corante: exports.yupCamposRematricula.label('Alergia a Corante'),
    inseto: exports.yupCamposRematricula.label('Alergia de picada de inseto'),
    leite: exports.yupCamposRematricula.label('Alergia de Leite'),
    ovo: exports.yupCamposRematricula.label('Alergia a ovo'),
    cirurgia: exports.yupCamposRematricula.label('Fez cirurgia'),
    doenca: exports.yupCamposRematricula.label('Teve doenças graves no passado'),
    psicologo: exports.yupCamposRematricula.label('Acompanhamento Psicológico'),
    pedagogo: exports.yupCamposRematricula.label('Acompanhamento Psicopedagógico'),
    fono: exports.yupCamposRematricula.label('Acompanhamento Fonoaudiológico'),
    remedio: exports.yupCamposRematricula.label('Medicamento de uso contínuo'),
    atividades: exports.yupCamposRematricula.label('Restrição para fazer atividade física'),
    medico: exports.yupCamposRematricula.label('Acompanhamento médico'),
    aremedio: exports.yupCamposRematricula.label('Alergia a medicamentos/ remédio'),
    alimentar: exports.yupCamposRematricula.label('Outras Alergias'),
    fisico: exports.yupCamposRematricula.label('Transtorno específico do desenvolvimento de função motora (deficiência física)'),
    visual: exports.yupCamposRematricula.label('Deficiência visual'),
    auditivo: exports.yupCamposRematricula.label('Defasagem no Processo Auditivo Central (P.A.C)'),
    mental: exports.yupCamposRematricula.label('Defasagem entre a idade cronologia e intelectual (deficiência mental)'),
    discalculi: exports.yupCamposRematricula.label('Transtorno específico das habilidades matemáticas.'),
    linguagem: exports.yupCamposRematricula.label('Transtorno específico da linguagem.'),
    emocional: exports.yupCamposRematricula.label('Transtorno emocional e do comportamento.'),
    nee: exports.yupCamposRematricula.label('POSSUI necessidades educativas e/ou de atendimento especiais'),
    tdah: exports.yupCamposRematricula.label('Transtorno do Distúrbio da Atenção/Hiperatividade'),
});
exports.schemaCamposMatriculaFichaSaude = exports.yupCamposMatriculaFichaSaude.shape({});
exports.yupCamposMatriculaResponsavel = yup.object({
    NOME_RESP: exports.yupCamposRematricula.label('Nome'),
    NASC_RESP: exports.yupCamposRematricula.label('Data de Nascimento'),
    CPF_RESP: exports.yupCamposRematricula.label('CPF'),
    RG_RESP: exports.yupCamposRematricula.label('RG'),
    RG_EXP_RES: exports.yupCamposRematricula.label('Órgão Expedidor'),
    RG_UF_RESP: exports.yupCamposRematricula.label('Unidade da Federação (UF)'),
    RG_EXPDTRE: exports.yupCamposRematricula.label('Data de Expedição'),
    END_RESP: exports.yupCamposRematricula.label('Endereço'),
    NUM_RESP: exports.yupCamposRematricula.label('Número'),
    BLOCO_RESP: exports.yupCamposRematricula.label('Bloco'),
    APTO_RESP: exports.yupCamposRematricula.label('Apartamento'),
    BAIRR_RESP: exports.yupCamposRematricula.label('Bairro'),
    CEP_RESP: exports.yupCamposRematricula.label('CEP'),
    CX_POST_R: exports.yupCamposRematricula.label('Caixa Postal'),
    CID_RESP: exports.yupCamposRematricula.label('Cidade'),
    UF_RESP: exports.yupCamposRematricula.label('Estado'),
    FONE_RRESP: exports.yupCamposRematricula.label('Telefone (Residencial)'),
    CELULAR_RE: exports.yupCamposRematricula.label('Celular'),
    EMAIL_RESP: exports.yupCamposRematricula.label('E-mail'),
    CIVIL_RESP: exports.yupCamposRematricula.label('Estado Civil'),
    PROF_RESP: exports.yupCamposRematricula.label('Profissão'),
    RENDA_RESP: exports.yupCamposRematricula.label('Renda'),
    DEPEN_RESP: exports.yupCamposRematricula.label('Dependente'),
    TRAB_RESP: exports.yupCamposRematricula.label('Trabalho'),
    FONE_RESP: exports.yupCamposRematricula.label('Telefone (Comercial)'),
    RAMAL_RESP: exports.yupCamposRematricula.label('Ramal'),
    RELIG_RESP: exports.yupCamposRematricula.label('Religião'),
    INSTR_RESP: exports.yupCamposRematricula.label('Instrução'),
    NATUR_RESP: exports.yupCamposRematricula.label('Naturalidade'),
    NACIO_RESP: exports.yupCamposRematricula.label('Nacionalidade'),
    PAI_RESP: exports.yupCamposRematricula.label('Nome do Pai'),
    MAE_RESP: exports.yupCamposRematricula.label('Nome do Mãe'),
});
exports.schemaCamposMatriculaResponsavel = exports.yupCamposMatriculaResponsavel.shape({});
exports.yupCamposMatriculaFiador = yup.object({
    NOME_F: exports.yupCamposRematricula.label('Nome'),
    NASC_F: exports.yupCamposRematricula.label('Data de Nascimento'),
    CPF_F: exports.yupCamposRematricula.label('CPF'),
    RG_F: exports.yupCamposRematricula.label('RG'),
    RG_EXP_F: exports.yupCamposRematricula.label('Órgão Expedidor'),
    RG_UF_F: exports.yupCamposRematricula.label('Unidade da Federação (UF)'),
    RG_EXPDT_F: exports.yupCamposRematricula.label('Data de Expedição'),
    END_F: exports.yupCamposRematricula.label('Endereço'),
    NUM_F: exports.yupCamposRematricula.label('Número'),
    BLOCO_F: exports.yupCamposRematricula.label('Bloco'),
    APTO_F: exports.yupCamposRematricula.label('Apartamento'),
    BAIRR_F: exports.yupCamposRematricula.label('Bairro'),
    CEP_F: exports.yupCamposRematricula.label('CEP'),
    CX_POST_F: exports.yupCamposRematricula.label('Caixa Postal'),
    CID_F: exports.yupCamposRematricula.label('Cidade'),
    UF_F: exports.yupCamposRematricula.label('Estado'),
    FONE_R_F: exports.yupCamposRematricula.label('Telefone (Residencial)'),
    CELULAR_F: exports.yupCamposRematricula.label('Celular'),
    EMAIL_F: exports.yupCamposRematricula.label('E-mail'),
    CIVIL_F: exports.yupCamposRematricula.label('Estado Civil'),
    PROF_F: exports.yupCamposRematricula.label('Profissão'),
    RENDA_F: exports.yupCamposRematricula.label('Renda'),
    DEPEN_F: exports.yupCamposRematricula.label('Dependente'),
    TRAB_F: exports.yupCamposRematricula.label('Trabalho'),
    FONE_F: exports.yupCamposRematricula.label('Telefone (Comercial)'),
    RAMAL_F: exports.yupCamposRematricula.label('Ramal'),
    RELIG_F: exports.yupCamposRematricula.label('Religião'),
    INSTR_F: exports.yupCamposRematricula.label('Instrução'),
    NATUR_F: exports.yupCamposRematricula.label('Naturalidade'),
    NACIO_F: exports.yupCamposRematricula.label('Nacionalidade'),
    PAI_F: exports.yupCamposRematricula.label('Nome do Pai'),
    MAE_F: exports.yupCamposRematricula.label('Nome do Mãe'),
});
exports.schemaCamposMatriculaFiador = exports.yupCamposMatriculaFiador.shape({});
exports.yupCamposMatriculaFinalizar = yup.object({
    NOME_SERIE: exports.yupCamposRematricula.label('Série para Rematrícula'),
    DTMENSAL: exports.yupCamposRematricula.label('Dia de Pgto da Mensalidade'),
    T_ANUIDADE: exports.yupCamposRematricula.label('Anuidade'),
    FPANUIDADE: exports.yupCamposRematricula.label('Forma de pagamento da anuidade'),
    PCANUIDADE: exports.yupCamposRematricula.label('Nº de Parcelas da Anuidade'),
    DCANUIDADE: exports.yupCamposRematricula.label('% Desconto da Anuidade'),
    VRANUIDADE: exports.yupCamposRematricula.label('Vr das Parcelas da Anuidade'),
    T_MATERIAL: exports.yupCamposRematricula.label('Total do Material'),
    FPMATERIAL: exports.yupCamposRematricula.label('Forma de Pgto do Material'),
    PCMATERIAL: exports.yupCamposRematricula.label('Nº de Parcelas do material'),
    DCMATERIAL: exports.yupCamposRematricula.label('% Desconto do material'),
    VRMATERIAL: exports.yupCamposRematricula.label('Vr das Parcelas do material'),
    DTMATERIAL: exports.yupCamposRematricula.label('Dia de Pgto do material'),
    T_ENTRADA: exports.yupCamposRematricula.label('Total da Entrada'),
    FPENTRADA: exports.yupCamposRematricula.label('Forma de Pgto da Entrada'),
    PCENTRADA: exports.yupCamposRematricula.label('Nº de Parcelas da Entrada'),
    DCENTRADA: exports.yupCamposRematricula.label('% Desconto da entrada'),
    VRENTRADA: exports.yupCamposRematricula.label('Vr das Parcelas da entrada'),
    DTENTRADA: exports.yupCamposRematricula.label('Dia de Pgto da entrada'),
});
exports.schemaCamposMatriculaFinalizar = exports.yupCamposMatriculaFinalizar.shape({});
exports.yupCamposMatriculaPessoasAutorizadas = yup.object({
    nome: exports.yupCamposRematricula.label('Nome'),
    sobrenome: exports.yupCamposRematricula.label('Sobrenome'),
    cpf: exports.yupCamposRematricula.label('CPF'),
    rg: exports.yupCamposRematricula.label('RG'),
    celular: exports.yupCamposRematricula.label('Celular'),
    telefone: exports.yupCamposRematricula.label('Telefone'),
    parentesco: exports.yupCamposRematricula.label('Parentesco'),
});
exports.schemaCamposMatriculaPessoasAutorizadas = exports.yupCamposMatriculaPessoasAutorizadas.shape({});
exports.yupCamposMatriculaTransporteEscolar = yup.object({
    nome: exports.yupCamposRematricula.label('Nome'),
    tipo: exports.yupCamposRematricula.label('Tipo de pessoa'),
    cnpj: exports.yupCamposRematricula.label('CPF ou CNPJ'),
    nomePessoa: exports.yupCamposRematricula.label('Nome da pessoa'),
    sobrenomePessoa: exports.yupCamposRematricula.label('Sobrenome da pessoa'),
    telefonePessoa: exports.yupCamposRematricula.label('Telefone da pessoa'),
    celularPessoa: exports.yupCamposRematricula.label('Celular da pessoa'),
});
exports.schemaCamposMatriculaTransporteEscolar = exports.yupCamposMatriculaTransporteEscolar.shape({});
exports.yupConfigMatriculaRematricula = yup.object({
    aluno: exports.yupCamposMatriculaAluno,
    pai: exports.yupCamposMatriculaPai,
    mae: exports.yupCamposMatriculaMae,
    saude: exports.yupCamposMatriculaFichaSaude,
    responsavel: exports.yupCamposMatriculaResponsavel,
    fiador: exports.yupCamposMatriculaFiador,
    pessoasAutorizadas: exports.yupCamposMatriculaPessoasAutorizadas,
    transporteEscolar: exports.yupCamposMatriculaTransporteEscolar,
    finalizar: exports.yupCamposMatriculaFinalizar,
});
exports.schemaTabsRematricula = exports.yupConfigMatriculaRematricula.shape({});
const getDefaultTabsRematricula = (tabs) => {
    const defaultTabs = Object.keys(exports.yupConfigMatriculaRematricula.fields);
    defaultTabs.map((tab) => {
        var _a;
        if (!tabs)
            tabs = {};
        const tabType = tab;
        const schema = exports.yupConfigMatriculaRematricula.fields[tabType];
        tabs[tabType] = Object.keys(schema.fields).reduce((pre, cur) => {
            if (!pre[cur]) {
                return Object.assign(Object.assign({}, pre), { [cur]: exports.yupCamposRematricula.getDefault() });
            }
            return pre;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, (_a = tabs[tabType]) !== null && _a !== void 0 ? _a : {});
    });
    return tabs;
};
exports.getDefaultTabsRematricula = getDefaultTabsRematricula;
